import styled, { css } from "styled-components";

const color = css<{ disabled?: boolean }>`
  color: ${({ theme, disabled }) => {
    if (disabled) {
      return theme.colors.muted;
    }

    return theme.colors.secondary;
  }};
`;

const TextLink = styled.a<{ disabled?: boolean }>`
  font-size: 16px;
  font-family: ${({ theme }) => theme.font};
  text-decoration: none;
  ${color};
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  box-shadow: 0px 0px 0px ${({ theme }) => theme.colors.secondary};
  transition: box-shadow 100ms ease 0s;
  background: none;
  border: none;
  padding: 2px 0;
  appearance: none;
  font-weight: 500;

  :link,
  :visited {
    ${color};
  }

  :hover {
    ${color};
    ${({ disabled, theme }) =>
      !disabled && `box-shadow: 0px 2px 0px ${theme.colors.secondary}`};
  }

  :focus {
    outline-width: 2px;
    outline-offset: 2px;
    outline-color: ${({ theme, disabled }) =>
      !disabled && theme.colors.primary};
`;

export default TextLink;
